import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
import { CallbackForm } from '../components/CallbackForm';
import { Footer } from '../components/Footer';
import { AuthorByline } from '../components/AuthorComponents';
import { ReviewsShowcase } from '../components/ReviewComponents';
import { translations } from '../translations';
import { localizePath } from '../i18nRoutes';
import './seo-pages.css';
import './PrivateIstanbulTours.css';

import { LayoverCalculator } from '../components/LayoverCalculator';
import { useLayoverConfig } from '../data/layoverConfig';
import { HUB_CONTENT } from '../data/layoverHubContent';
import { hubUrl, childPath, LayoverGuarantee, LayoverSiblingNav, LayoverPriceBlock, LayoverCommonBlocks, buildLayoverSchema } from '../components/LayoverShared';

export default function LayoverToursPage({ language }) {
  const lang = language === 'ar' ? 'ar' : 'en';
  const t = translations[language];
  const cfg = useLayoverConfig();
  const c = HUB_CONTENT[lang](cfg);
  const url = hubUrl(lang);
  const homeUrl = lang === 'ar' ? 'https://viaturkey.net/ar' : 'https://viaturkey.net/';
  const schema = buildLayoverSchema({ cfg, url, lang, name: c.schemaName, description: c.schemaDesc, itinerary: c.schemaItinerary, faqs: c.faqs,
    breadcrumbs: [{ name: c.bcHome, url: homeUrl }, { name: c.bcHub, url }] });

  return (
    <div className="pit-page" data-testid="layover-page">
      <SEOHead title={c.seoTitle} description={c.seoDesc} canonical={url} schema={schema} />

      <article className="pit-container" style={{ paddingTop: '110px' }}>
        <div className="pit-body" data-testid="layover-body">

          <h1>{c.h1}</h1>
          <p className="gp-last-updated" data-testid="layover-last-updated"><em>{c.lastUpdated}</em></p>

          <AuthorByline publishDate={c.publishDate} updateDate={c.updateDate} />

          <LayoverGuarantee cfg={cfg} lang={lang} />

          <p>{c.intro}</p>

          <p data-testid="layover-galataport-link-text">{c.cruiseBefore}<Link to={localizePath('/tours/galataport-shore-excursions', lang)} data-testid="layover-galataport-link">{c.cruiseLink}</Link>{c.cruiseAfter}</p>

          <h2>{c.h2Calc}</h2>
          <LayoverCalculator cfg={cfg} lang={lang} />

          <h2>{c.h2Hours}</h2>
          <p>{c.hours1}</p>
          <p>{c.hours2}</p>

          <h2>{c.h2Transfers}</h2>
          <table className="gp-table" data-testid="layover-transfer-table">
            <thead><tr><th>{c.thRoute}</th><th>{c.thEachWay}</th></tr></thead>
            <tbody>
              {c.transferRows.map((r, i) => <tr key={i}><td>{r[0]}</td><td>{r[1]}</td></tr>)}
            </tbody>
          </table>
          <p className="gp-table-note"><em>{c.tableNote}</em></p>

          <h2>{c.h2Fits}</h2>
          <div className="lo-children" data-testid="layover-children-grid">
            {c.cards.map(card => <Link key={card.slug} to={childPath(card.slug, lang)} className="lo-child-card"><h3>{card.h3}</h3><p>{card.p}</p></Link>)}
          </div>

          <h2>{c.h2Food}</h2>
          <p>{c.food}</p>

          <h2>{c.h2Tourist}</h2>
          {c.tourist.map((p, i) => <p key={i}>{p}</p>)}
          <p>{c.official}<a href="https://www.turkishairlines.com/en-tr/flights/fly-different/touristanbul/" target="_blank" rel="noopener noreferrer" data-testid="touristanbul-official-link">turkishairlines.com/touristanbul</a></p>

          <h2>{c.h2Visa}</h2>
          <p>{c.visa1}</p>
          <p>{c.visa2}</p>

          <h2>{c.h2Luggage}</h2>
          <p>{c.lug1}</p>
          <p><strong>{c.lugStrong}</strong></p>
          <div className="gp-table-wrap" data-testid="layover-luggage-table">
            <table className="gp-table">
              <thead><tr><th>{c.thSize}</th><th>{c.thPrice}</th></tr></thead>
              <tbody>
                {c.luggageRows.map((r, i) => <tr key={i}><td>{r[0]}</td><td>{r[1]}</td></tr>)}
              </tbody>
            </table>
          </div>
          <p className="gp-table-note"><em>{c.lugNote}</em></p>
          <p>{c.lug2}</p>

          <h2>{c.h2Pricing}</h2>
          <LayoverPriceBlock cfg={cfg} lang={lang} />

          <LayoverCommonBlocks cfg={cfg} airport="IST" lang={lang} meet={c.meet} dontBook={c.dontBook} />

          <h2>{c.h2Faq}</h2>
          {c.faqs.map((f, i) => (
            <details key={i} className="gp-faq-item" data-testid={`layover-faq-${i}`}><summary>{f.q}</summary><p>{f.a}</p></details>
          ))}

          <LayoverSiblingNav lang={lang} />

          <ReviewsShowcase layover />
          <h2>{c.h2Flight}</h2>
          <CallbackForm language={language} sourcePage="layover-tours" />
        </div>
      </article>
      <Footer t={t} />
    </div>
  );
}
